"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextAvailability = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Displays info about next availability of a sold out product.
 * Does not render if `title` has falsy value.
 */
const NextAvailability = ({
  title,
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!title) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.NEXT_AVAILABILITY),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Box, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      fontWeight: "bold",
      children: title
    })]
  });
};
exports.NextAvailability = NextAvailability;
//# sourceMappingURL=NextAvailability.js.map